import * as React from "react";

function SvgGauge(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 23.96 15.97"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M9.74 12.12a2.23 2.23 0 00.87 3.29 2.21 2.21 0 003.28-.88c.82-1.44 6-14.26 5.59-14.53s-8.92 10.69-9.74 12.12zM12 3a8.65 8.65 0 011.54.13C14 2.46 14.63 1.73 15.2 1A11.76 11.76 0 0012 .58C5.26.58 0 6.27 0 13.52c0 .45 0 .9.06 1.33a1.2 1.2 0 002.39-.21 10.38 10.38 0 01-.05-1.12C2.4 7.62 6.61 3 12 3zm8.65 1.5c-.33.9-.69 1.82-1 2.61a11.28 11.28 0 011.94 6.42 10.74 10.74 0 01-.06 1.14A1.21 1.21 0 0022.6 16h.11a1.2 1.2 0 001.19-1.09c0-.45.06-.9.06-1.36a13.47 13.47 0 00-3.33-9.06z" />
    </svg>
  );
}

const MemoSvgGauge = React.memo(SvgGauge);
export default MemoSvgGauge;
